//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('docPackTypes', {
//        templateUrl: 'views/components/views/docPackTypes/docPackTypes.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'docpacktype_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            }).setLoadDataFunction({
//                method: 3283,
//                parameters: {}
//            }).setCustomToolbarButtons([{
//                name: 'docpacktypes_new',
//                text: 'docpacktypes_new',
//                func: () => stateService.go('docpacktype', { docpacktype_keyno: '0' }),
//                icon: 'fa-plus',
//                cssClass: 'btn btn-primary im-grid-btn-xs-r',
//                translate: true
//            }]);
            
//            // #endregion VARIABLES & DEFINITIONS

//        }]
//    });
//})();
